/**
 * @module AuthContext
 * @summary Exports a React Context Provider & Consumer
 */
import React from 'react'

const { Provider, Consumer } = React.createContext()

export { Provider, Consumer }
